export const NAVIGATION_STATE_KEY = 'NAVIGATION_STATE';
export const NAVIGATION_TIMESTAMP_KEY = 'NAVIGATION_TIMESTAMP';
export const NAVIGATION_URL_KEY = 'NAVIGATION_URL';
